module.exports = "<div v-if=note transition=modal class=backdrop v-on:click=dismissModal> <form class=edit-note v-on:submit.prevent=update v-on:click.stop=\"\"> <input name=title v-model=note.title placeholder=Title /> <textarea name=content v-model=note.content placeholder=\"Text goes here...\" rows=8>\n    </textarea> <button type=button v-on:click=remove> <i class=\"fa fa-trash-o\" aria-hidden=true></i> </button> <button type=submit>Done</button> </form> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notes/UpdateModal.vue
 ** module id = 84
 ** module chunks = 0
 **/